import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '@/config/i18n'
import { initSentry } from '@/config/sentry'
import { App } from './App'
import { QueryProvider } from './context/QueryProvider'
import { ErrorBoundary } from '@/components/error'

// Initialize Sentry before rendering
initSentry()

window.addEventListener('vite:preloadError', () => window.location.reload())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <App />
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>
)
